export const getInternasjonaleOverforingerFields = () => ({
    land: null,
    hvorfor: null,
    belop: null,
    antOverforinger: null,
});

const hasValueWithLength = (val, minLength = 0) => val && val.trim().length > minLength;

const isValueOnlyDigits = (value) => {
    return /^\d+$/.test(value);
};

export const isValidOverforingField = (key, val) => {
    switch (key) {
        case 'land':
            return hasValueWithLength(val);
        case 'hvorfor':
            return hasValueWithLength(val, 10);
        case 'belop':
            return isValueOnlyDigits(val) && parseInt(val, 10) >= 1 && parseInt(val, 10) < 999999999000;
        case 'antOverforinger':
            return isValueOnlyDigits(val) && parseInt(val, 10) >= 1 && parseInt(val, 10) < 1000;
        default:
            return false;
    }
};
